export default __webpack_public_path__ + "static/media/Belt of the Crimson Fort.6229f014.jpg";